import React, { useState } from 'react';
import {
  Row,
  Col,
  Container,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Spinner,
} from 'reactstrap';

import '../../../assets/scss/datatables.scss';
import { MetaTags } from 'react-meta-tags';
import { DashBreadcrumb } from '../../../components/Common/Breadcrumb';
import NonSaleApprovalList from './NonSaleApprovalList';
import { updateNonSaleApprovalStatus } from './actions/action';
import { useDispatch } from 'react-redux';
import toast, { Toaster } from 'react-hot-toast';

const NonSaleApprovals = () => {
  const dispatch = useDispatch();
  const [confirmModal, setConfirmModal] = useState({
    show: false,
    id: null,
    status: null,
  });
  const [refreshTrigger, setRefreshTrigger] = useState(0);
  const [isUpdating, setIsUpdating] = useState(false);

  let approvedById = '';
  let approvedByName = '';
  if (localStorage.getItem('authUser')) {
    const userObj = JSON.parse(localStorage.getItem('authUser'));
    approvedById = userObj?.user_id ?? '';
    approvedByName = userObj?.user_name ?? '';
  }

  const handleChangeStatus = (id, newStatus) => {
    setConfirmModal({ show: true, id, status: newStatus });
  };

  const closeConfirmModal = () =>
    setConfirmModal({ show: false, id: null, status: null });

  const confirmStatusChange = async () => {
    const { id, status } = confirmModal;
    setIsUpdating(true);
    try {
      const response = await updateNonSaleApprovalStatus({
        id,
        status,
        approvedById,
        approvedByName,
        dispatch,
      });
      if (response?.data?.code === 100) {
        toast.success(`Approval ${status} successfully!`);
        closeConfirmModal();
        setRefreshTrigger((prev) => prev + 1);
      } else {
        toast.error(response?.data?.message || 'Failed to update status');
      }
    } catch (error) {
      toast.error('Something went wrong!');
    } finally {
      setIsUpdating(false);
    }
  };

  return (
    <>
      <div className="page-content">
        <MetaTags>
          <title>Non Sale Approvals</title>
        </MetaTags>
        <Container fluid>
          <Row>
            <Col xl={4}>
              <DashBreadcrumb
                title="Service Orders"
                breadcrumbItem="Non Sale Approvals"
              />
            </Col>
            <Col xl={8}></Col>
          </Row>

          <NonSaleApprovalList
            onChangeStatus={handleChangeStatus}
            refreshTrigger={refreshTrigger}
          />

          <Modal isOpen={confirmModal.show} toggle={closeConfirmModal} centered>
            <ModalHeader toggle={closeConfirmModal}>Confirm Action</ModalHeader>
            <ModalBody className="text-center py-4">
              <i
                className={`mdi mdi-alert-circle-outline display-4 mb-3 ${
                  confirmModal.status === 'approved'
                    ? 'text-success'
                    : 'text-danger'
                }`}
              ></i>
              <h5>
                Are you sure you want to {confirmModal.status} this approval
                request?
              </h5>
              <p className="text-muted">
                This action will mark the item as{' '}
                <strong>{confirmModal.status}</strong>.
              </p>
            </ModalBody>
            <ModalFooter className="gap-2">
              <Button
                color="btn btn-light"
                outline
                onClick={closeConfirmModal}
                disabled={isUpdating}
              >
                Cancel
              </Button>
              <Button
                color={
                  confirmModal.status === 'approved' ? 'success' : 'danger'
                }
                onClick={confirmStatusChange}
                disabled={isUpdating}
              >
                {isUpdating && <Spinner size="sm" className="me-2" />}
                Yes,{' '}
                {confirmModal.status === 'approved' ? 'Approve' : 'Reject'} it
              </Button>
            </ModalFooter>
          </Modal>
        </Container>
      </div>
      <Toaster position="top-right" reverseOrder={false} />
    </>
  );
};

export default NonSaleApprovals;
